//智能咨询地址
let baseURL, protocol = 'https://',
    hostName = '';
if (process.env.NODE_ENV === 'development') {
    hostName = "robot.odrcloud.cn";
} else if (process.env.NODE_ENV === 'production') {
    if (process.env.VUE_APP_TYPE === "test") {
        hostName = 'robot.odrcloud.cn'
    } else if (process.env.VUE_APP_TYPE === "dev") {
        hostName = '119.3.38.125:19099'
    } else if (process.env.VUE_APP_TYPE === 'prod') {
        hostName = "robot.odrcloud.cn";
    } else {
        hostName = 'robot.odrcloud.cn'
    }
}
baseURL = protocol + hostName

export default {
    baseURL: baseURL
}